import { ProductTypeEnum } from '@/types/ProductType';

export const productTypeLabels: Record<ProductTypeEnum, string> = {
  [ProductTypeEnum.TRACK]: 'Track',
  [ProductTypeEnum.ALBUM]: 'Album',
  [ProductTypeEnum.LINK]: 'Link',
  [ProductTypeEnum.MERCH]: 'Merch',
  [ProductTypeEnum.VIDEO]: 'Video',
  [ProductTypeEnum.LIVESTREAM]: 'Livestream',
  [ProductTypeEnum.EVENT]: 'Event',
  [ProductTypeEnum.TOUR]: 'Tour',
  [ProductTypeEnum.TICKET]: 'Ticket',
  [ProductTypeEnum.MEETING]: 'Meeting',
};

export const productTypeSelectOptions = Object.values(ProductTypeEnum).map(
  (value) => ({
    value,
    label: productTypeLabels[value],
  }),
);
